<template>
  <div
      class="modal fade"
       id="brands_popup"
       tabindex="-1"
       data-backdrop="static"
       data-keyboard="false"
       role="dialog"
       aria-labelledby="myModalLabel"
  >
    <div
        class="modal-dialog"
        role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="resetBrandData"
              aria-label="Close"
              :disabled="uploadingItems"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
              class="modal-title"
              id="brandsPopUp">
            Add/ Update Brands {{(this.branchId !== 0) ? ": " + this.branchName : ""}}
          </h4>
        </div>
        <div class="modal-body">
          <form v-if="branchId === 0" id="brandsForm"
                method="post"
                @submit.prevent="addNewBrand()"
                enctype="multipart/form-data">
            <div class="row">

              <div class="col-lg-5">
                <div class="form-group">
                  <label>Name</label>
                  <input v-model="brand.name"
                         type="text"
                         class="form-control"
                         required="required"
                         placeholder="Name...">
                </div>
              </div>

              <div class="col-lg-5">
                <div class="form-group">
                  <label>
                    Brand Logo
                  </label>
                  <br/>
                  <input v-on:change="handlePicture()"
                         type="file"
                         class="form-control"
                         id="brand_logo"
                         placeholder="Logo..."
                  >
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <button class="btn btn-primary btn-md"
                          style="margin-top: 25px"
                          type="submit"
                          title="Save"
                          :disabled="uploadingItems"
                  >
                    <i class="fa fa-plus"/>
                  </button>
                </div>
              </div>

            </div>
            <div v-if="uploadingItems" class="row">
              <div class="form-group">
                <div class="progress"
                >
                  <div id="progress-bar"
                       class="progress-bar progress-bar-success progress-bar-striped active"
                       role="progressbar"
                       :style="{width: uploadImagePercentage+'%'}"
                       :aria-valuenow="uploadImagePercentage"
                       aria-valuemin="0"
                       aria-valuemax="100"
                  >
                    {{uploadImagePercentage}}%
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="table-responsive"
               style="overflow: auto">
            <table class="table table-striped table-bordered table-hover responsive"
                   id="dtTable"
            >
              <thead>
              <tr>
                <th>Image</th>
                <th>Brand</th>
                <th v-if="branchId === 0" class="text-center"><i class="fa fa-bolt action_btn"></i></th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="allBrands.length === 0">
                <td colspan="4" style="text-align: left">No brand is available in this branch.</td>
              </tr>
              <tr v-else v-for="brands in allBrands" :key="brands.id" >
                <td class="col-md-8">
                  <img v-bind:src="brands.logo"
                         alt="No image found"
                       style="max-width: 20% ;max-height: 20%">
                </td>
                <td>
                  {{ brands.name }}
                </td>
                <td v-if="branchId === 0"
                     class="text-center">
                  <a href="javascript:void(0)"
                     title="Delete Brand"
                     style="color: inherit;"
                  >
                    <i v-on:click="deleteBrand(brands.id)" class="fa fa-lg fa-trash"/>
                  </a>
                </td>
              </tr>

              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {addNewBrand, deleteBrand, fetchAllBrands, fetchAllBrandsOfBranch} from "@/api/brands";

export default {
  name: "LoadAllBrands",
  data() {
    return {
      allBrands: [],
      update:false,
      brand: {
        "id": 0,
        "name": "",
      },
      brandLogo: "",
      branchId: 0,
      branchName: "",
      uploadingItems: false,
      uploadImagePercentage: 0,
      editingBrand: false,
    }
  },
  components: {
    Multiselect
  },
  mounted() {
    $('#brands_popup').on('hidden.bs.modal',  (e) => {
      Object.assign(this.$data, this.$options.data.call(this));
    });
  },
  methods: {
    resetBrandData () {
      this.brandLogo = "";
      this.brand = {
        "id": 0,
        "name": "",
      };
      $('#brandsForm')[0].reset();
      $('#brand_logo').val('');
    },
    async loadBabyHugBrands(branchId = 0, branchName = ""){
      this.showLoading()
      await this.loadBrands()
      if(branchId > 0){
        this.branchId = branchId;
        this.branchName = branchName;
        await this.loadBrandsOfBranch()
      }
      setTimeout(() => {
        Swal.close()
        $("#brands_popup").modal("show");
      }, 500);

    },
    async loadBrands(){
      let allBrandsResp = await fetchAllBrands()
          .catch(ex => {
            this.showErrorMessage(ex)
          });
      if(allBrandsResp.data.status === 200){
        this.allBrands = allBrandsResp.data.body;
      }else{
        this.showErrorMessage(allBrandsResp)
      }
    },
    async loadBrandsOfBranch() {
      let brandsOfBranchResp = await fetchAllBrandsOfBranch(this.branchId)
          .catch(ex => {
            this.showErrorMessage(ex)
          });
      if(brandsOfBranchResp.data.status === 200){
        this.allBrands = brandsOfBranchResp.data.body;
        swal("Success", "Successfully fetch brands of " + this.branchName + "!", "success")
      }else{
        this.showErrorMessage(brandsOfBranchResp)
      }
    },
    async addNewBrand() {
      let self = this;
      this.uploadingItems= true;
      let formData = new FormData();
      formData.append("brands", JSON.stringify(this.brand))
      formData.append("brandLogo", this.brandLogo)
      let config ={
        headers: {
          'Content-Type': 'multipart/form-data;'
        },
        onUploadProgress: function (progressEvent){
          if(progressEvent.lengthComputable) {
            self.uploadImagePercentage = Math.round((progressEvent.loaded * 100)/ progressEvent.total);
          }
        }.bind(self)
      };
      let newBrandResp = await addNewBrand(formData, config)
          .catch(ex => {
            this.showErrorMessage(ex)
          });
      if(newBrandResp.data.status === 200){
        await this.loadBrands()
        this.resetBrandData()
        swal("Success", "Successfully add new Brands!", "success")
      }else{
        this.showErrorMessage(newBrandResp)
      }
      this.uploadingItems = false;
      this.editingBrand = false;
    },
    async deleteBrand (brandId) {
      let deleteBrandConfirmation = await this.confirmFromUserBeforeDeleting("Are You Sure You Want To Delete this Brand?");
      if (deleteBrandConfirmation.value) {
        this.showLoading()
        let deleteBrandResp = await deleteBrand(brandId)
            .catch(ex => {
              this.showErrorMessage(ex)
            });
        if (deleteBrandResp.data.status === 200) {
          swal("Success", deleteBrandResp.data.message, "success")
          await this.loadBrands()
        } else {
          this.showErrorMessage(deleteBrandResp)
        }
      }
    },
    async editBrand (brand){
      this.brand = brand;
      this.brand.logo = "";
      this.brandLogo = brand.logo;
      this.editingBrand = true;
    },
    handlePicture() {
      let input =$("#brand_logo");
      if (input.prop('files')[0] !== undefined) {
        var reader = new FileReader();
        reader.onload = function(e) {
          input.prev().attr('src', e.target.result);
        };
        reader.readAsDataURL(input.prop('files')[0]);
        this.brandLogo = input.prop('files')[0];
      }else{
        input.prev().attr('src', "");
      }
    },
  }
}
</script>

<style scoped>

</style>